/* eslint-disable no-empty */
/* eslint-disable react/button-has-type */
/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-cycle */
import { useEffect, useMemo, useState } from 'react';

import { Quote } from '@meterup/connect-api';

export default function useConnectionTypeFilter(quotes: Quote[]) {
  const quotesByConnectionType = useMemo(() => {
    const sortedQuotes = [...quotes].sort(
      (a, b) => (a.monthlyFeeCents ?? 0) - (b.monthlyFeeCents ?? 0),
    );
    return sortedQuotes.reduce<Record<string, typeof quotes>>((acc, quote) => {
      const key = quote?.connectionType?.name || 'unknown';
      (acc[key] ??= []).push(quote);
      return acc;
    }, {});
  }, [quotes]);
  const allConnectionTypes = useMemo(() => Object.keys(quotesByConnectionType).sort(), [quotes]);
  const [currentConnectionTypes, setCurrentConnectionTypes] = useState(allConnectionTypes);

  useEffect(() => {
    setCurrentConnectionTypes(allConnectionTypes);
  }, [allConnectionTypes]);

  const onCurrentConnectionTypesChange = (connectionType: string, checked: boolean) => {
    const connectionTypesSet = new Set(currentConnectionTypes);
    if (connectionTypesSet.has(connectionType) && !checked) {
      connectionTypesSet.delete(connectionType);
    } else {
      connectionTypesSet.add(connectionType);
    }

    setCurrentConnectionTypes([...connectionTypesSet]);
  };

  const resetCurrentConnectionTypes = () => {
    setCurrentConnectionTypes(allConnectionTypes);
  };

  return {
    allConnectionTypes,
    currentConnectionTypes,
    onCurrentConnectionTypesChange,
    quotesByConnectionType,
    resetCurrentConnectionTypes,
  };
}
